import { useParams, useSearchParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../redux/hook"
import { useEffect } from "react"
import { getPublishedReport } from "../service/apiAccessLogic"
import { msalInstance } from "../index"
import { setCurrentControlBoard, setCurrentReport } from "../redux/dataSlice"
import ViewBoardContainer from "../components/viewBoard/ViewBoardContainer"
import PageNotFound from "./PageNotFound"

const RenderPage = () => {
    const currentReport = useAppSelector(state => state.data.currentReport)
    const pathSegments = window.location.pathname.split("/").filter(Boolean) 
    const dispatch = useAppDispatch()

    // params for published reports
    const customerId = useParams().customerId
    const reportId = useParams().reportId
    
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get("page") || "-1")
    const bg = parseInt(searchParams.get("bg") || "0")
    const showHeader = searchParams.get("showHeader") === "true" ? true : false
    
    useEffect(() => {
        if (pathSegments.includes("publishedReport")) {
            if (customerId === undefined || reportId === undefined) return
            if (currentReport && currentReport.customer_id === customerId && currentReport.report_id === reportId) return

            getPublishedReport(msalInstance, customerId, reportId)
                .then((response) => {
                    dispatch(setCurrentReport(response.data))
                    const reportType = (response.data.report_id as unknown as string).split("_").slice(0, 3).join("_")
                    dispatch(setCurrentControlBoard(reportType))
                })
                .catch((e) => {
                    console.error(e)
                })
        }
    })
    
    const bgGray = bg == 1 ? "bg-transparent" : "bg-neutral-50"

    if (pathSegments.includes("publishedReport")) {
        return (
            <div className={`w-full flex flex-col items-center min-h-screen bg-cover ${bgGray}`} >
                <ViewBoardContainer page={page} bgColor={bg == 1 ? "bg-transparent" : "bg-neutral-50"} renderPage={true} showHeader={showHeader}/>
            </div>
        )
    } else {
        return <PageNotFound />       
    }

}

export default RenderPage